{
  "name": "hipotecas-pibank",
  "version": "1.88.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=4300",
    "build": "ng build",
    "serve:des": "ng serve --port=4300 --c=des",
    "serve:test": "ng serve --port=4300 --c=test",
    "serve:beta": "ng serve --port=4300 --c=beta",
    "serve:prod": "ng serve --port=4300 --c=prod",
    "build:des": "ng build --c=des",
    "build:test": "ng build --c=test",
    "build:beta": "ng build --c=beta",
    "build:prod": "ng build --configuration=production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "prepare": "husky"
  },
  "private": true,
  "lint-staged": {
    "*{js,ts,html,yml,md,scss,css,json}": [
      "prettier --write"
    ]
  },
  "dependencies": {
    "@angular/animations": "^20.3.16",
    "@angular/common": "^20.3.16",
    "@angular/compiler": "^20.3.16",
    "@angular/core": "^20.3.16",
    "@angular/forms": "^20.3.16",
    "@angular/platform-browser": "^20.3.16",
    "@angular/platform-browser-dynamic": "^20.3.16",
    "@angular/platform-server": "^20.3.16",
    "@angular/router": "^20.3.16",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^4.0.0",
    "animate.css": "^3.6.1",
    "bootstrap": "^5.3.5",
    "core-js": "^2.4.1",
    "file-saver": "^1.3.3",
    "font-awesome": "^4.7.0",
    "google-maps": "^3.3.0",
    "iban": "0.0.12",
    "lodash": "^4.17.15",
    "ngx-clipboard": "^15.1.0",
    "ngx-device-detector": "^10.0.0",
    "ngx-infinite-scroll": "^20.0.0",
    "primeicons": "^6.0.1",
    "primeng": "^20.3.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.15",
    "@angular/cli": "^20.3.15",
    "@angular/compiler-cli": "^20.3.16",
    "@angular/language-service": "^20.3.16",
    "@types/file-saver": "^1.3.0",
    "@types/grecaptcha": "^3.0.9",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.2",
    "@types/lodash": "^4.17.10",
    "@types/node": "^22.0.0",
    "codelyzer": "^6.0.0",
    "husky": "^9.1.6",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-sonarqube-reporter": "^1.4.0",
    "karma-spec-reporter": "^0.0.36",
    "lint-staged": "^15.2.10",
    "prettier": "3.3.3",
    "prettier-plugin-organize-imports": "^4.1.0",
    "protractor": "~7.0.0",
    "terser": "^3.14.1",
    "ts-node": "~3.2.0",
    "tslint": "~6.1.0",
    "typescript": "^5.4.5"
  }
}
